import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33337 10.3333C4.78109 10.3333 4.33337 10.781 4.33337 11.3333C4.33337 11.8856 4.78109 12.3333 5.33337 12.3333C5.88566 12.3333 6.33337 11.8856 6.33337 11.3333C6.33337 10.781 5.88566 10.3333 5.33337 10.3333ZM3.33337 11.3333C3.33337 10.2287 4.2288 9.33329 5.33337 9.33329C6.43794 9.33329 7.33337 10.2287 7.33337 11.3333C7.33337 12.4379 6.43794 13.3333 5.33337 13.3333C4.2288 13.3333 3.33337 12.4379 3.33337 11.3333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.16671 3.66663C7.70645 3.66663 7.33337 4.03972 7.33337 4.49996V11.3333C7.33337 11.6094 7.10952 11.8333 6.83337 11.8333C6.55723 11.8333 6.33337 11.6094 6.33337 11.3333V4.49996C6.33337 3.48744 7.15416 2.66663 8.16671 2.66663H12.1667C13.1793 2.66663 14 3.48744 14 4.49996V9.33329C14 9.60944 13.7762 9.83329 13.5 9.83329C13.2239 9.83329 13 9.60944 13 9.33329V4.49996C13 4.03972 12.627 3.66663 12.1667 3.66663H8.16671Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8.33329C11.4478 8.33329 11 8.78101 11 9.33329C11 9.88558 11.4478 10.3333 12 10.3333C12.5523 10.3333 13 9.88558 13 9.33329C13 8.78101 12.5523 8.33329 12 8.33329ZM10 9.33329C10 8.22872 10.8955 7.33329 12 7.33329C13.1046 7.33329 14 8.22872 14 9.33329C14 10.4379 13.1046 11.3333 12 11.3333C10.8955 11.3333 10 10.4379 10 9.33329Z"
      fill="currentColor"
    />
  </SvgIcon>
));
